import api from './api';
import types from './mutation-types';
import moment from 'moment';

//날짜 포맷 변경 함수
const dateFormat = ts => {
	if (!ts) return ts;
	return moment(ts).format('YYYY-MM-DD HH:mm:ss');
};

export default {
	//State 변경 Action
	setState_({ commit }, { key, value }) {
		commit(types.SET_STATE, { key, value });
	},

	//공장 코드 조회
	getPlantList_({ commit, state, rootState }) {
		return api
			.getPlantList()
			.then(res => {
				if (res.header.code === 0) {
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'plantOptions', value }); //Select Box Options 값 Vuex에 저장
					commit(types.SET_STATE, { key: 'searchParams', value: { ...state.searchParams, plantCd: rootState.commonStore.user.plantCd } }); //Select Box Options 값 Vuex에 저장
				}

				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//공통 코드 조회: 사용 유무
	getUseYnList_({ commit, rootState }) {
		return api
			.getUseYnList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'USE_YN' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					// const getMessage_ = rootGetters['commonStore/getMessage_']; //전역 Store의 다국어 처리 getter 호출
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'useYnOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//부서코드 : 2022-07-21 snjung
	getDeptCdList_({ commit, rootState }) {		
		return api
			.getDeptCdList() //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					// const getMessage_ = rootGetters['commonStore/getMessage_']; //전역 Store의 다국어 처리 getter 호출
					const value = res.body.map(({ deptCd, deptNm }) => ({ label: deptNm, value: deptCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'deptCdOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 타입: 2022-07-21 snjung
	getEmployeeTypeList_({ commit, rootState }) {
		return api
			.getEmployeeTypeList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'EMPLOYEE_TYPE' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					// const getMessage_ = rootGetters['commonStore/getMessage_']; //전역 Store의 다국어 처리 getter 호출
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'employeeTypeOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//조회 Action
	select_({ commit }, { currentPage, pageUnit, ...params }) {
		return api
			.select({ params, currentPage, pageUnit })
			.then(res => {
				if (res.header.code === 0) {
					const {
						resultList,
						pagingInfo: { currentPage, pageUnit, totalSize }
					} = res.body;

					//날짜 포맷 변경
					const data = resultList.map(row => ({
						...row,
						dRegDt: dateFormat(row.regDt),
						dLastLoginDt: dateFormat(row.lastLoginDt),
						dLastPwdChgDt: dateFormat(row.lastPwdChgDt)
					}));

					//테이블 페이징 조회를 위한 검색조건 저장
					commit(types.SET_STATE, { key: 'searchParams', value: params });
					//조회 데이터 저장
					commit(types.SET_STATE, { key: 'users', value: { currentPage, pageUnit, totalSize, data } });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 추가/수정/삭제(미사용 처리)
	setUsers_({ dispatch, state, rootState }, params) {
		const updatedParams = params.map(param => {
			delete param.dRegDt;
			delete param.dLastLoginDt;
			delete param.dLastPwdChgDt;
			return param;
		});
		return api
			.setUsers({ plantCd: rootState.commonStore.user.plantCd, params: updatedParams })
			.then(res => {
				if (res.header.code === 0) {
					//사용자 정보 추가/변경/삭제 성공시 사용자 재조회
					dispatch('select_', {
						currentPage: state.users.currentPage,
						pageUnit: state.users.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 비밀번호 초기화
	resetPassword_({ dispatch, state, rootState }, params) {
		return api
			.resetPassword({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(res => {
				if (res.header.code === 0) {
					//비밀번호 변경 성공시 사용자 재조회
					dispatch('select_', {
						currentPage: state.users.currentPage,
						pageUnit: state.users.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	}
};
